export const superadminLoginState = {
    userName: "",
    password: "",
    isLoading: false,
    Message: "",
    loginStatus: 0,
    authTokenId: "",
    brandList:[],
    authAppUser:{},
    adminId: 0,
    activateAppUserSucceeded:false,
    loginDetails:{},
    removeAccountObject:{},
    EisCodeVerified:false,
    VisCodeVerified:false
}